var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-tooltip" }, [
    _c(
      "button",
      {
        ref: "toggle",
        staticClass: "c-tooltip__button c-button c-button--icons",
        on: { click: _vm.openDialog },
      },
      [
        _c("span", { staticClass: "c-button__icon" }, [_vm._v("?")]),
        _vm._v("\n        " + _vm._s(_vm.text) + "\n    "),
      ]
    ),
    _vm._v(" "),
    _c(
      "dialog",
      {
        ref: "dialog",
        staticClass: "c-tooltip__dialog",
        attrs: { popover: "auto", tabindex: "-1" },
      },
      [
        _c("button", {
          staticClass: "c-tooltip__close c-button-close",
          on: { click: _vm.closeDialog },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-tooltip__content" },
          [_vm._t("default")],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }